<template>
  <li class="list_once">
    <p class="p">如何设置到期提醒？</p>
    <p class="text">1. 在文件管理 --已结束页面中，选择需要设置提醒的电子合同文件-更多操作-设置提醒</p>
    <img class="img" src="/images/home/sign_img19.png" alt="">
    <p class="text">2.通过设置提醒弹窗，输入手机号和提醒日期，即可在指定的提醒日期发送到期提醒短信给设置的手机号。系统同时支持设置多个通知手机号和日期。</p>
    <img class="img" src="/images/home/sign_img20.png" alt="">
  </li>
</template>
<script>
  export default {
    data () {
      // 这里存放数据
      return {}
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .list_once {
    font-size: 14px;
    padding: 10px;
    .p {
      font-size: 16px;
      font-weight: bold;
    }
    .text {
      margin: 10px 0;
    }
    .img {
      max-width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// pages/dingtalkUse/helpCenterCom/29_expireRemind.vue